<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    iconSrc?: string;
    title?: string;
    color?: string;
    orientation?: 'horizontal' | 'vertical';
  }>(),
  {
    iconSrc: undefined,
    title: '',
    color: '#f1f1ff',
    orientation: 'vertical',
  }
);
</script>

<template>
  <div
    :class="['item', `item_orientation_${props.orientation}`]"
    :style="`background: ${props.color}`"
  >
    <img :src="props.iconSrc" />
    <div>
      <div class="title">{{ props.title }}</div>
      <div class="text">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.item {
  height: 100%;
  padding: 32px;
  border-radius: 24px;

  &_orientation_horizontal {
    @include media-breakpoint-up(sm) {
      display: flex;
      align-items: center;
      gap: 28px;
    }
  }

  img {
    width: 152px;
    height: 152px;
    margin-bottom: 24px;
  }

  .title {
    margin-bottom: 12px;
    font-weight: 600;
    font-size: 24px;
    line-height: 28px;
  }

  .text {
    font-size: 17px;
    line-height: 24px;
  }
}
</style>
